module.exports = __webpack_public_path__ + "img/searching.b082f6a5.svg";